import type { AppAbility } from '~/types/authorization.type'
import { useAbility } from '@casl/vue'

export const useAppAbility = () => useAbility<AppAbility>()
